const settings = {
    filetypes: [
        'jpg',
        'jpeg',
        'png'
    ],
    maxFileSize: 2097152, // Equals to 2 MB

    errorFilesize: 'error-filesize',
    errorFiletype: 'error-filetype'
};

export default (el) => {
    let fileInput = el.querySelector('input[type="file"]'),
        label = el.querySelector('label'),

        filetypes = (el.getAttribute('data-iu-filetypes')) ? JSON.parse(el.getAttribute('data-iu-filetypes')) : settings.filetypes,
        maxFileSize = (el.getAttribute('data-iu-filesize')) ? el.getAttribute('data-iu-filesize') : settings.maxFileSize,

        getFileExtension = (fileName) => {
            let temp = fileName.split('.');
            return temp[temp.length - 1];
        },

        fileValidation = (file) => {

            if (filetypes.indexOf(getFileExtension(file.name).toLowerCase()) < 0) {
                el.classList.add(settings.errorFiletype);
                el.classList.remove(settings.errorFilesize);

                return false;
            } else if (file.size > maxFileSize) {
                el.classList.remove(settings.errorFiletype);
                el.classList.add(settings.errorFilesize);

                return false;
            }

            el.classList.remove(settings.errorFiletype);
            el.classList.remove(settings.errorFilesize);

            return true;
        },

        setPreviewImage = (file) => {
            if (!fileValidation(file)) {
                return;
            }

            let reader = new FileReader();

            reader.addEventListener('load', function onLoad() {
                label.style.backgroundImage = 'url(' + reader.result + ')';

                reader.removeEventListener('load', onLoad);
            });

            if (file) {
                reader.readAsDataURL(file);
            }
        },

        bindEvents = () => {
            fileInput.addEventListener('change', (e) => setPreviewImage(e.target.files[0]));

            // Bind drag&drop events
            label.addEventListener('dragenter', () => {
                label.classList.add('drag-over');
            });

            label.addEventListener('dragover', (e) => {
                e.stopPropagation();
                e.preventDefault();
            });

            label.addEventListener('dragleave', () => {
                label.classList.remove('drag-over');
            });

            label.addEventListener('drop', (e) => {
                e.stopPropagation();
                e.preventDefault();

                label.classList.remove('drag-over');

                setPreviewImage(e.dataTransfer.files[0]);
            });
        };

    bindEvents();
};
